import { Checkbox, Datetime, Field, Select } from "components/shared/form";
import { bidRefuelingServiceTypesEnum } from "helpers/enums";
import policy from "policies";
import React from "react";

const RefuelingPlanning = (props) => {
    const { data, onChange, config, roles } = props;
    const renderField = (fieldConfig, prefix) => {
        const isDateTime = fieldConfig.inputProps.type === "datetime";
        const Component = fieldConfig.isSelect
            ? Select
            : fieldConfig.isCheckbox
              ? Checkbox
              : isDateTime
                ? Datetime
                : Field;
        const value = prefix
            ? data[prefix]
                ? data[prefix][fieldConfig.inputProps.name]
                : ""
            : data[fieldConfig.inputProps.name];
        const onFieldChange = ({ name, value }) => {
            if (prefix) {
                const newValue = { ...data[prefix], [name]: value };
                onChange({ name: prefix, value: newValue });
            } else {
                onChange({ name, value });
            }
        };
        return (
            <Component
                {...fieldConfig}
                value={value}
                onChange={onFieldChange}
                disabled={!policy("user", { user: { roles } }).isAdminWithWriteAccess()}
            />
        );
    };

    const formFields = () => {
        switch (data.refuelingServiceType) {
            case bidRefuelingServiceTypesEnum.MultiGo:
                return renderField(config.multiGo.accessKey, "multiGo");
            case bidRefuelingServiceTypesEnum.Delkon:
                return (
                    <>
                        {renderField(config.delkon.accessKey, "delkon")}
                        {renderField(config.delkon.userName, "delkon")}
                        {renderField(config.delkon.password, "delkon")}
                    </>
                );
            case bidRefuelingServiceTypesEnum.Str:
                return (
                    <>
                        {renderField(config.str.userName, "str")}
                        {renderField(config.str.password, "str")}
                    </>
                );
            case bidRefuelingServiceTypesEnum.MultiGo2:
                return [renderField(config.multiGo2.accessKey, 0, "multiGo2")];
            case bidRefuelingServiceTypesEnum.SolarFrps:
                return (
                    <>
                        {renderField(config.solarFrps.baseUrl, "solarFrps")}
                        {renderField(config.solarFrps.username, "solarFrps")}
                        {renderField(config.solarFrps.password, "solarFrps")}
                        {renderField(config.solarFrps.updatingPeriod, "solarFrps")}
                        {renderField(config.solarFrps.isFuelLimitEnabled, "solarFrps")}
                        {renderField(config.solarFrps.filterByFuelCardType, "solarFrps")}
                        {renderField(config.solarFrps.hideRefuelingPlanning, "solarFrps")}
                        {renderField(config.solarFrps.sendPlannedBidPath, "solarFrps")}
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <>
            {renderField(config.refuelingServiceType)}
            {renderField(config.addCarToRefuelingSyncByDefault)}
            {renderField(config.addTrailerToRefuelingSyncByDefault)}
            {renderField(config.isRefuelingPlanLimitedToOnce)}
            {renderField(config.skipPlanningForPastBids)}
            {renderField(config.basePeriodStartDate)}
            {formFields()}
        </>
    );
};

export default RefuelingPlanning;
